import { createGlobalStyle } from 'styled-components'

/*
 * One typeface for the whole site: Barlow, a low-contrast grotesque that
 * Stony Brook lists among its approved secondary faces. Running a single
 * family at moderate weights — rather than a condensed display face over a
 * slab serif — is what gives modern marketing sites their clean, unfussy feel.
 *
 * Headings lean on size and weight for hierarchy, not on uppercase or wide
 * tracking. Large sizes get slightly negative tracking so they set tightly.
 */
const GlobalStyles = createGlobalStyle`
  :root {
    --font-sans: 'Barlow', -apple-system, BlinkMacSystemFont, 'Segoe UI',
      Helvetica, Arial, sans-serif;

    --fs-display-xl: clamp(2.75rem, 5.2vw, 4.5rem);
    --fs-display-lg: clamp(2rem, 3.6vw, 3rem);
    --fs-display-md: clamp(1.75rem, 2.8vw, 2.5rem);
    --fs-heading-lg: clamp(1.3rem, 1.7vw, 1.55rem);
    --fs-heading-md: 1.2rem;
    --fs-heading-sm: 1.0625rem;
    --fs-body-lg: 1.1875rem;
    --fs-body: 1.0625rem;
    --fs-body-sm: 0.9375rem;
    --fs-label: 0.8125rem;

    --radius-sm: 8px;
    --radius-md: 14px;
    --radius-lg: 20px;
    --radius-pill: 999px;
  }

  html {
    scroll-behavior: smooth;
  }

  @media (prefers-reduced-motion: reduce) {
    html { scroll-behavior: auto; }
    *, *::before, *::after {
      animation-duration: 0.001ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.001ms !important;
    }
  }

  body {
    background-color: #FAFAF8;
    font-family: var(--font-sans);
    font-size: var(--fs-body);
    font-weight: 400;
    line-height: 1.6;
    color: #4B4B4B; /* Stony Brook Dark Gray */
    -webkit-font-smoothing: antialiased;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: var(--font-sans);
    font-weight: 600;
    /* Inherit, never force a colour: headings on the navy and dark sections
       rely on picking up white from their container. */
    color: inherit;
    margin: 0 0 0.5em;
  }

  h1 {
    font-size: var(--fs-display-lg);
    line-height: 1.06;
    letter-spacing: -0.02em;
  }

  h2 {
    font-size: var(--fs-display-md);
    line-height: 1.14;
    letter-spacing: -0.017em;
  }

  h3 {
    font-size: var(--fs-heading-lg);
    line-height: 1.28;
    letter-spacing: -0.008em;
  }

  h4 { font-size: var(--fs-heading-md); line-height: 1.35; }
  h5, h6 { font-size: var(--fs-heading-sm); line-height: 1.4; }

  button, input, select, textarea {
    font-family: var(--font-sans);
  }

  img { max-width: 100%; }

  :focus-visible {
    outline: 3px solid #D52027; /* Stony Brook Bright Red */
    outline-offset: 3px;
  }
`
export default GlobalStyles
